import React, { useState, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import "./styles.scss";
import SocialMediaSubmenu from "../../../../shared/SocialMediaSubmenu";
import { ReactComponent as MenuIcon } from "../../../../../../public/shared/menu-icon-default.svg";
import { ReactComponent as DeleteIcon } from "../../../../../../public/shared/delete-icon.svg";
import { ReactComponent as ShareIcon } from "../../../../../../public/icons/MenuIcons/share.svg";
import { ReactComponent as MuteIcon } from "../../../../../../public/icons/MenuIcons/mute.svg";
import { ReactComponent as NextArrowIcon } from "../../../../../../public/icons/MenuIcons/next_arrow.svg";

import { Dropdown } from "react-bootstrap";
import { isSelfId } from "../../../../../../api/helper";
import { deletePost } from "../../../../../../api/posts";

export default ({ object, type, userId, socialMediaOnly = false, children, disabled, objectDeleter = undefined }) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const isMobileDevice = useMediaQuery({
    query: "(max-width: 1200px)",
  });
  let options = [{ id: 1, value: "share", text: "share", icon: ShareIcon }];
  if (objectDeleter && isSelfId(userId)) {
    options.push({ id: 2, value: "delete", text: "delete", icon: DeleteIcon });
  }
  const renderIcon = (value) => {
    switch (value) {
      case "share":
        return <ShareIcon />;
      case "mute":
        return <MuteIcon />;
      case "delete":
        return <DeleteIcon className="ml-n1" />;
      default:
        return;
    }
  };

  const onMenuTabClicked = async (o) => {
    if (o.value == "delete") {
      if (type === "Post") {
        await deletePost(object.id);
        objectDeleter(object.id);
      }
      if (type === "Playlist" || type === "Album" || type === "Podcast") {
        objectDeleter(object.id);
      }
    }
  };

  const showSubmenuHandler = (value, option) => {
    if (option.value !== "share") return;
    setShow(value);
  };

  const shareclick = (type, object) => {
    let shareUrl = "";
    switch (type) {
      case "Post":
        shareUrl = `${window.location.host}/post/${object.id}`;
      case "Playlist":
      case "Podcast":
      case "Album":
        if (object.user && object.user.username) {
          shareUrl = `${window.location.host.replace("http", "https")}/${object.user.slug}/${type.toLowerCase()}s/${object.id}`;
        }
      case "SoundTrack":
        shareUrl = object.shareable_link;
    }
    if (!navigator.share) return;
    navigator
      .share({
        text: "Check this out on HUDLMusic.com: " + shareUrl,
      })
      .then(() => {
        console.log("Shared!");
      })
      .catch((error) => {
        console.log("Sharing Failed");
      });
  };

  return options.length ? (
    <Dropdown className="post-menu">
      {children ? <Dropdown.Toggle as="div">{children}</Dropdown.Toggle> : <Dropdown.Toggle as={MenuIcon} />}

      <Dropdown.Menu style={socialMediaOnly ? { display: "flex", flexDirection: "row", alignItems: "center", height: 40 } : {}}>
        {socialMediaOnly ? (
          <SocialMediaSubmenu type={type} object={object} socialMediaOnly={socialMediaOnly} />
        ) : (
          options.map((o, i) => (
            <Dropdown.Item
              id={o.value}
              className="position-relative"
              key={o.id}
              onMouseEnter={() => showSubmenuHandler(true, o)}
              onMouseLeave={() => showSubmenuHandler(false, o)}
              onClick={() => onMenuTabClicked(o)}
              ref={o.value === "share" ? target : null}
            >
              <div className="d-flex">
                {o.icon && (
                  <span className="mr-1" style={{ width: 24 }}>
                    {renderIcon(o.value)}
                  </span>
                )}
                <span className="text">{o.text}</span>
                {o.icon && o.value === "share" && <NextArrowIcon height="12" width="12" className="ml-auto mt-2" />}
              </div>
              {o.icon && o.value === "share" && <SocialMediaSubmenu type={type} object={object} target={target} show={show} />}
            </Dropdown.Item>
          ))
        )}
      </Dropdown.Menu>
    </Dropdown>
  ) : null;
};
